import { render } from "./ReceiptTax.vue?vue&type=template&id=350740f5"
import script from "./ReceiptTax.vue?vue&type=script&lang=js"
export * from "./ReceiptTax.vue?vue&type=script&lang=js"
script.render = render
/* hot reload */
if (module.hot) {
  script.__hmrId = "350740f5"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('350740f5', script)) {
    api.reload('350740f5', script)
  }
  
  module.hot.accept("./ReceiptTax.vue?vue&type=template&id=350740f5", () => {
    api.rerender('350740f5', render)
  })

}

script.__file = "src/icons/components/filled/ReceiptTax.vue"

export default script